import Signal from 'libs/signals';

const tokenSignal = Signal({});

export default tokenSignal;
